import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=520c0ae0&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=ts"
export * from "./Registro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c0ae0",
  null
  
)

export default component.exports